import React, { useEffect } from 'react'
import { FuseAnimateGroup } from '@fuse'
import RegisterForm from './RegisterForm'
import { useSuspendStatus } from 'app/auth/useSuspendStatus'
import Suspended from 'app/components/Suspended'
import CommonBackground from 'app/components/CommonBackground'
import ContainerNotifyMeCard from 'app/components/ContainerNotifyMeCard'
import { useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'
import MessageAlert from 'app/components/MessageAlert'
import { useAppName } from 'commons/usePartner'

function Login({ history, location }) {
  const { suspendStatus, clearSuspendStatus } = useSuspendStatus()
  const { formatMessage } = useIntl()
  const dispatch = useDispatch()
  const appName = useAppName()

  useEffect(() => {
    if (suspendStatus.teamMember)
      dispatch(
        MessageAlert.showError({
          message: formatMessage(
            {
              id: 'suspended.teamMember',
            },
            { newline: <br />, appName },
          ),
        }),
      )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [suspendStatus.teamMember, dispatch, formatMessage])

  return (
    <CommonBackground>
      {suspendStatus.place ? (
        <ContainerNotifyMeCard>
          <div className="flex flex-col">
            <Suspended
              reason={suspendStatus.place}
              onClose={clearSuspendStatus}
            />
          </div>
        </ContainerNotifyMeCard>
      ) : (
        <ContainerNotifyMeCard
          footerMessage={formatMessage({
            id: 'login.contentBottom',
          })}
        >
          <div className="flex flex-col w-full">
            <FuseAnimateGroup
              enter={{ animation: 'fadeIn' }}
              leave={{ animation: 'fadeOut' }}
            >
              <RegisterForm location={location} history={history} />
            </FuseAnimateGroup>
          </div>
        </ContainerNotifyMeCard>
      )}
    </CommonBackground>
  )
}

export default Login
